import { useMemo } from 'react';
import { useListUsers as useListUsersApi } from '@/shared/api/generated/users';
import { User } from '../model';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { UserListResponse } from '@/shared/api';

type UseListUsersOptions = {
  query?: Partial<UseQueryOptions<UserListResponse>>;
};

const emptyUsers: User[] = [];

/**
 * Hook to get list of users (team members) as User class instances
 * Wraps the generated API hook and transforms the response
 */
export const useUsers = (options?: UseListUsersOptions) => {
  const query = useListUsersApi(undefined, options);

  const users = useMemo(() => {
    if (!query.data) {
      return emptyUsers;
    }

    return query.data.map((userData) => new User(userData));
  }, [query.data]);

  return {
    ...query,
    data: users,
  };
};
